import { SocialMediaClass } from "../models/socialmedia";
import { accountConstants } from "../constants/account.constants";


export function account(state = { loading: false }, action) {
    switch (action.type) {
        case accountConstants.SEARCH_REQUEST:
            // console.log("request")
            return {
                name: "",
                accountList: "",
                loading: true,
                done: false
            };
        case accountConstants.SEARCH_SUCCESS:
            // console.log(action.payload)
            return {
                name: action.payload[0],
                accountList: action.payload[1],
                loading: false,
                done: true
            };
        case accountConstants.SEARCH_FAILURE:
            // console.log(action.payload)
            return {
                error: action.payload[0],
                name: action.payload[1],
                accountList: "",
                loading: false,
                done: true
            };
        case accountConstants.SEARCH_FAILURE_DONE:
            return {
                name: "",
                accountList: "",
                loading: false,
                done: false
            };
        default:
            // console.log("in default")
            // console.log(state)
            return state;
    }
}